import React, { useState, useEffect, useRef, useContext } from "react";
import ClickOutside from "react-outside-click-handler";
import ClassNames from "classnames";
import { useTransition, animated } from "react-spring";

import Button from "../Button";
// import ZChat from "../ZChat";
import { ChatbotState } from "../Layout";

// Icons
import { faPhoneAlt, faComment } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClickToCall from "../ClickToCall";

import globalContent from "../../../content/global";
import { getStaticData } from "../../helperFunctions";

import * as s from "./s.module.scss";

// Custom Inside Chat CSS
import "./customInsideChat.css";

const BDNumber = "+63288629551";

const ContactFloatingButton = ({ officeCountry, locale }) => {
  const notProd = process.env.GATSBY_ACTIVE_ENV !== "production"; // TODO: Remove this once chatbot released
  const isStaging = process.env.GATSBY_ACTIVE_ENV === "staging";
  const isDev = process.env.GATSBY_ACTIVE_ENV === "development";
  const { setChatbotOpen } = useContext(ChatbotState);
  const animationDelay = 150;
  const [show, setShow] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [zChatActive, setZChatActive] = useState(false);
  const [contactButtonActive, setContactButtonActive] = useState(true);
  const clickToCall = useRef();

  const chatButton = {
    optionName: "chatButton",
    // text:
    //   typeof window !== "undefined" &&
    //   window.location.hostname.split(".").slice(-1)[0] === "cn" // show different text on tdcx.cn
    //     ? getStaticData(globalContent.get_in_touch, locale).floating_button.title
    //     : getStaticData(globalContent.get_in_touch, locale).floating_button.chat,
    text: "",
    onClick: e => {
      e.preventDefault();
      setZChatActive(false);
      setExpanded(false);
      setContent(initialOption);
      window.insideFrontInterface.openChatPane();
      setContactButtonActive(true);
      if (isDev) {
        setChatbotOpen(true);
      }
    },
    icon: <FontAwesomeIcon icon={faComment} />
    // iconPosition: "left"
  };

  const clickToCallButton = {
    optionName: "clickToCall",
    hide:
      typeof window !== "undefined" &&
      window.location.hostname.split(".").slice(-1)[0] === "cn", // hide click-to-call button on tdcx.cn
    text: getStaticData(globalContent.get_in_touch, locale).floating_button.call,
    onClick: e => {
      e.preventDefault();
      // BD Team from Philippines request:
      // If it's Philippines, change career number to BD Team
      let officeNumber =
        officeCountry[0].country_name === "Philippines"
          ? BDNumber
          : officeCountry[0].office_info_details[0].phone_number;
      clickToCall.current.handleClick(officeNumber, locale);
      setExpanded(false);
      setContent(initialOption);
    },
    icon: <FontAwesomeIcon icon={faPhoneAlt} />,
    iconPosition: "left"
  };

  let initialOption;

  if (
    typeof window !== "undefined" &&
    window.location.hostname.split(".").slice(-1)[0] === "cn"
  ) {
    initialOption = [chatButton]; // only  show chat button on tdcx.cn
  } else {
    initialOption = [
      chatButton
      // {
      //   text: getStaticData(globalContent.get_in_touch, locale).floating_button.title,
      //   onClick: e => {
      //     e.preventDefault();
      //     setContent(options);
      //     setExpanded(true);
      //   },
      //   iconMobileOnly: <FontAwesomeIcon icon={faComment} />
      // }
    ];
  }

  const [content, setContent] = useState(initialOption);

  let options = [chatButton, clickToCallButton];
  const [displayed, setDisplayed] = useState(initialOption);

  const config = { mass: 1, tension: 2000, friction: animationDelay };
  const transitions = useTransition(show, null, {
    config,
    from: { opacity: 0, transform: "translateY(-16px) scale(0.96)" },
    enter: { opacity: 1, transform: "translateY(0px) scale(1)" },
    leave: { opacity: 0, transform: "translateY(16px) scale(0.96)" }
  });

  useEffect(() => {
    /*
     * when content state change, set the state to false,
     * so that the bubble will animating out.
     */
    setShow(false);
    /*
     * When botMessage props changed, don't set the message until
     * the out animation finished.
     */
    let timer = setTimeout(() => {
      setDisplayed(content);
    }, animationDelay);

    return () => clearTimeout(timer);
  }, [content]);

  /*
   * Now the message has changed, set the state to true,
   * but wait until the animation out finished
   */
  useEffect(() => {
    let timer;
    if (show === false) {
      timer = setTimeout(() => {
        setShow(true);
      }, animationDelay);
    }
    return () => clearTimeout(timer);
  }, [show]);

  return (
    <ClickOutside
      onOutsideClick={() => {
        if (expanded) {
          setExpanded(false);
          setContent(initialOption);
          setZChatActive(false);
        }
      }}
    >
      <ClickToCall ref={clickToCall} options={true} BDNumber={BDNumber} />
      <div
        className={ClassNames(s.wrapper, s.contactFloatingButton, {
          [s.hide]: !contactButtonActive
        })}
      >
        <div className={ClassNames(s.buttonWrapper, { [s.expanded]: expanded })}>
          {transitions.map(({ item, key, props }) => {
            return (
              item && (
                <animated.div key={key} style={{ ...props }}>
                  {displayed.map((data, i) => {
                    return (
                      !data.hide && (
                        <React.Fragment key={i}>
                          {i > 0 && "|"}
                          <Button
                            variant="secondary"
                            className={ClassNames(s.button, {
                              [s.iconMobileOnlyBtn]: data.iconMobileOnly
                            })}
                            onClick={data.onClick}
                            icon={data.icon && data.icon}
                            iconPosition={data.iconPosition && data.iconPosition}
                            link="#"
                          >
                            {data.iconMobileOnly && (
                              <span className={s.iconMobileOnly}>
                                {data.iconMobileOnly}
                              </span>
                            )}
                            <span>{data.text}</span>
                          </Button>
                        </React.Fragment>
                      )
                    );
                  })}
                </animated.div>
              )
            );
          })}
        </div>
      </div>
    </ClickOutside>
  );
};

export default ContactFloatingButton;
